(function ($) {
    $(".section-home-hero").each(function (index) {
        const linksCount = $(this).find('.item').length;
        console.log(linksCount)
        if (linksCount > 2) {
            $(this).find(".container").addClass("more-than-two");
        }
    })

})(jQuery);